import React, { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

interface IWeekChipProps {
  label: string;
  isActive: boolean;
  canRemove: boolean;
  onSelect: () => void;
  onRemove: () => void;
}

export const WeekChip: FC<IWeekChipProps> = ({
  label,
  isActive,
  canRemove,
  onSelect,
  onRemove
}) => {
  const handleRemove = (e: React.MouseEvent): void => {
    e.stopPropagation();
    onRemove();
  };

  return (
    <button
      type="button"
      onClick={onSelect}
      className={[
        'inline-flex items-center justify-center gap-[6px] min-w-[83px] h-8 py-2 px-[10px] rounded-md transition-colors',
        isActive
          ? 'border border-indigo-600 bg-indigo-50 text-indigo-700'
          : 'bg-base-accent text-base-primary hover:brightness-95'
      ].join(' ')}
    >
      {canRemove && (
        <span
          role="button"
          tabIndex={0}
          aria-label={`Remove ${label}`}
          className="flex w-4 h-4 justify-center items-center cursor-pointer"
          onClick={handleRemove}
        >
          <FontAwesomeIcon
            icon="fa-regular fa-xmark"
            className="text-[10px]"
          />
        </span>
      )}
      <span className="text-p-xs font-medium leading-none">{label}</span>
    </button>
  );
};
